"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const appSelectControlParentById_1 = __importDefault(require("./appSelectControlParentById"));
const appStateSelectBO_1 = __importDefault(require("./appStateSelectBO"));
const appStateSelectFC_1 = __importDefault(require("./appStateSelectFC"));
const appStateSelectControlParentById = (controlId) => (state) => {
    if (!controlId) {
        return undefined;
    }
    const parent = (0, appSelectControlParentById_1.default)({
        buildOrders: (0, appStateSelectBO_1.default)(state),
        controlId,
        flattedControls: (0, appStateSelectFC_1.default)(state),
    });
    return parent;
};
exports.default = appStateSelectControlParentById;
